import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const FoodSafetyQuiz = ({ appData, submitQuiz }) => {
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "foodSafetyQuiz";
  const onboarding = appData.davinFoodsOnboarding;

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Food Safety at Davin Foods quiz as part of your
          induction with Reynolds.
        </p>
      ),
    },
    rules: {
      title: "1. Why do we have so many rules to keep food safe?",
      value: getVal("rules"),
      type: "radio",
      radioOptions: [
        "To protect our business",
        "To protect our customers",
        "It is the law",
        "All of the above",
      ],
      mandatory: true,
    },
    temperature: {
      title: "2. What temperature should we store food at?",
      value: getVal("temperature"),
      type: "radio",
      radioOptions: [
        "Less than 5\u2103",
        "Less than 8\u2103",
        "Less than 3\u2103",
        "Always check the label for details",
      ],
      mandatory: true,
    },
    risk: {
      title: "3. What are high risk foods?",
      value: getVal("risk"),
      type: "radio",
      radioOptions: [
        "Food that is expensive",
        "Food that is open",
        "Food that is dangerous",
        "Food that is ready to eat and must be kept in perfect condition to ensure it is safe",
      ],
      mandatory: true,
    },
    contaminate: {
      title: "4. Which of these can contaminate product?",
      value: getVal("contaminate"),
      type: "radio",
      radioOptions: [
        "Nail clippings",
        "Bacteria from hands",
        "Allergens from spillage",
        "Physical, Microbiological, Allergens and Chemicals can all contaminate product",
      ],
      mandatory: true,
    },
    unsure: {
      title: "5. If unsure about anything I should…",
      value: getVal("unsure"),
      type: "radio",
      radioOptions: [
        "Let it go",
        "Report it to my Manager",
        "Solve the problem myself",
        "Ask one of my team members",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Food Safety Induction at Davin Foods Quiz (PR902)"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
FoodSafetyQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FoodSafetyQuiz);
